import { FilterMultiselectValue } from "./FilterMultiselect";

export function isStringFilterValue(
    value: FilterMultiselectValue,
): value is string {
    return typeof value === "string";
}
